import {
  WbSunnyOutlined,
  CloudOutlined,
  CloudySnowing,
  AcUnitOutlined,
  Foggy,
  ThunderstormOutlined,
} from '@mui/icons-material';

// Dummy data was structured after Open Meteo but switching to another API like Openweather isn't going to be as hard either

// based on standard WMO weather codes
export const mapIconToWeatherCode = (weatherCode: number) => {
  switch (weatherCode) {
    case 0:
      return <WbSunnyOutlined fontSize="inherit" />;
    case 1:
    case 2:
    case 3:
      return <CloudOutlined fontSize="inherit" />;
    case 51:
    case 53:
    case 55:
    case 61:
    case 63:
    case 65:
    case 80:
    case 81:
    case 82:
      return <CloudySnowing fontSize="inherit" />;
    case 71:
    case 73:
    case 75:
      return <AcUnitOutlined fontSize="inherit" />;
    case 45:
    case 48:
      return <Foggy fontSize="inherit" />;
    case 95:
    case 96:
    case 99:
      return <ThunderstormOutlined fontSize="inherit" />;
    default:
      return <CloudOutlined fontSize="inherit" />;
  }
};

export const weatherCodeToDescription = (weatherCode: number) => {
  switch (weatherCode) {
    case 0:
      return 'Clear sky';
    case 1:
    case 2:
    case 3:
      return 'Cloudy';
    case 51:
    case 53:
    case 55:
    case 61:
    case 63:
    case 65:
    case 80:
    case 81:
    case 82:
      return 'Rainy';
    case 71:
    case 73:
    case 75:
      return 'Snowy';
    case 45:
    case 48:
      return 'Foggy';
    case 95:
    case 96:
    case 99:
      return 'Thunderstorm';
    default:
      return '-';
  }
};

export const mockWeatherDatasets = [
  {
    name: 'Heatwave Peak Scenario',
    latitude: 51.5,
    longitude: 0.25,
    generationtime_ms: 0.4123,
    utc_offset_seconds: 0,
    timezone: 'GMT',
    timezone_abbreviation: 'GMT',
    elevation: 1.0,
    current_units: {
      time: 'iso8601',
      interval: 'seconds',
      weather_code: 'wmo code',
      temperature_2m: '°C',
      apparent_temperature: '°C',
    },
    current: {
      time: '2026-06-03T10:00',
      interval: 900,
      weather_code: 1, // Mainly Clear
      temperature_2m: 29.5,
      apparent_temperature: 31.2,
    },
    hourly_units: {
      time: 'iso8601',
      temperature_2m: '°C',
      weather_code: 'wmo code',
      apparent_temperature: '°C',
    },
    hourly: {
      time: [
        '2026-06-03T00:00',
        '2026-06-03T01:00',
        '2026-06-03T02:00',
        '2026-06-03T03:00',
        '2026-06-03T04:00',
        '2026-06-03T05:00',
        '2026-06-03T06:00',
        '2026-06-03T07:00',
        '2026-06-03T08:00',
        '2026-06-03T09:00',
        '2026-06-03T10:00',
        '2026-06-03T11:00',
        '2026-06-03T12:00',
        '2026-06-03T13:00',
        '2026-06-03T14:00',
        '2026-06-03T15:00',
        '2026-06-03T16:00',
        '2026-06-03T17:00',
        '2026-06-03T18:00',
        '2026-06-03T19:00',
        '2026-06-03T20:00',
        '2026-06-03T21:00',
        '2026-06-03T22:00',
        '2026-06-03T23:00',
      ],
      temperature_2m: [
        21.0, 20.4, 19.8, 19.5, 19.2, 20.1, 21.8, 23.9, 26.0, 28.1, 29.5, 31.2, 32.4, 33.1, 33.5, 32.8, 31.9, 30.2,
        28.4, 26.7, 25.1, 23.9, 22.8, 22.0,
      ],
      weather_code: [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
      apparent_temperature: [
        21.5, 20.9, 20.0, 19.6, 19.1, 20.4, 22.2, 24.8, 27.3, 29.8, 31.2, 33.4, 35.0, 35.8, 36.2, 35.1, 33.9, 31.8,
        29.5, 27.6, 25.8, 24.4, 23.2, 22.4,
      ],
    },
  },
  {
    name: 'Dense Morning Fog to Clear Afternoon',
    latitude: 51.5,
    longitude: 0.25,
    generationtime_ms: 0.3851,
    utc_offset_seconds: 0,
    timezone: 'GMT',
    timezone_abbreviation: 'GMT',
    elevation: 1.0,
    current_units: {
      time: 'iso8601',
      interval: 'seconds',
      weather_code: 'wmo code',
      temperature_2m: '°C',
      apparent_temperature: '°C',
    },
    current: {
      time: '2026-06-03T10:00',
      interval: 900,
      weather_code: 45, // Fog
      temperature_2m: 12.0,
      apparent_temperature: 11.2,
    },
    hourly_units: {
      time: 'iso8601',
      temperature_2m: '°C',
      weather_code: 'wmo code',
      apparent_temperature: '°C',
    },
    hourly: {
      time: [
        '2026-06-03T00:00',
        '2026-06-03T01:00',
        '2026-06-03T02:00',
        '2026-06-03T03:00',
        '2026-06-03T04:00',
        '2026-06-03T05:00',
        '2026-06-03T06:00',
        '2026-06-03T07:00',
        '2026-06-03T08:00',
        '2026-06-03T09:00',
        '2026-06-03T10:00',
        '2026-06-03T11:00',
        '2026-06-03T12:00',
        '2026-06-03T13:00',
        '2026-06-03T14:00',
        '2026-06-03T15:00',
        '2026-06-03T16:00',
        '2026-06-03T17:00',
        '2026-06-03T18:00',
        '2026-06-03T19:00',
        '2026-06-03T20:00',
        '2026-06-03T21:00',
        '2026-06-03T22:00',
        '2026-06-03T23:00',
      ],
      temperature_2m: [
        10.5, 10.2, 9.9, 9.6, 9.4, 9.3, 9.5, 10.1, 10.8, 11.4, 12.0, 13.5, 15.2, 16.8, 17.5, 17.9, 17.6, 17.0, 15.8,
        14.5, 13.2, 12.4, 11.8, 11.2,
      ],
      weather_code: [3, 3, 45, 45, 45, 45, 45, 45, 45, 45, 45, 2, 1, 1, 0, 0, 0, 0, 0, 1, 1, 2, 3, 3],
      apparent_temperature: [
        9.8, 9.5, 9.0, 8.6, 8.3, 8.1, 8.4, 9.0, 9.8, 10.5, 11.2, 12.9, 14.6, 16.3, 17.0, 17.4, 17.1, 16.4, 15.1, 13.8,
        12.5, 11.6, 10.9, 10.3,
      ],
    },
  },
  {
    name: 'Passing Showers (Unstable Day)',
    latitude: 51.5,
    longitude: 0.25,
    generationtime_ms: 0.4912,
    utc_offset_seconds: 0,
    timezone: 'GMT',
    timezone_abbreviation: 'GMT',
    elevation: 1.0,
    current_units: {
      time: 'iso8601',
      interval: 'seconds',
      weather_code: 'wmo code',
      temperature_2m: '°C',
      apparent_temperature: '°C',
    },
    current: {
      time: '2026-06-03T10:00',
      interval: 900,
      weather_code: 80, // Slight Rain Showers
      temperature_2m: 16.2,
      apparent_temperature: 15.1,
    },
    hourly_units: {
      time: 'iso8601',
      temperature_2m: '°C',
      weather_code: 'wmo code',
      apparent_temperature: '°C',
    },
    hourly: {
      time: [
        '2026-06-03T00:00',
        '2026-06-03T01:00',
        '2026-06-03T02:00',
        '2026-06-03T03:00',
        '2026-06-03T04:00',
        '2026-06-03T05:00',
        '2026-06-03T06:00',
        '2026-06-03T07:00',
        '2026-06-03T08:00',
        '2026-06-03T09:00',
        '2026-06-03T10:00',
        '2026-06-03T11:00',
        '2026-06-03T12:00',
        '2026-06-03T13:00',
        '2026-06-03T14:00',
        '2026-06-03T15:00',
        '2026-06-03T16:00',
        '2026-06-03T17:00',
        '2026-06-03T18:00',
        '2026-06-03T19:00',
        '2026-06-03T20:00',
        '2026-06-03T21:00',
        '2026-06-03T22:00',
        '2026-06-03T23:00',
      ],
      temperature_2m: [
        13.8, 13.5, 13.2, 13.0, 13.2, 13.6, 14.2, 15.0, 15.5, 15.9, 16.2, 15.1, 16.5, 17.1, 15.4, 16.8, 17.2, 15.0,
        14.8, 14.2, 13.9, 13.7, 13.5, 13.2,
      ],
      weather_code: [
        2,
        2,
        3,
        3,
        1,
        1,
        2,
        80,
        2,
        3,
        80,
        81, // Sudden shower spikes
        2,
        1,
        81,
        2,
        1,
        80,
        3,
        3,
        2,
        1,
        1,
        2,
      ],
      apparent_temperature: [
        12.6, 12.2, 11.9, 11.5, 11.9, 12.4, 13.0, 13.8, 14.4, 14.8, 15.1, 13.9, 15.4, 16.1, 14.0, 15.8, 16.2, 13.7,
        13.5, 12.9, 12.6, 12.4, 12.1, 11.8,
      ],
    },
  },
  {
    name: 'Overcast and Gloomy (Static Temp)',
    latitude: 51.5,
    longitude: 0.25,
    generationtime_ms: 0.3541,
    utc_offset_seconds: 0,
    timezone: 'GMT',
    timezone_abbreviation: 'GMT',
    elevation: 1.0,
    current_units: {
      time: 'iso8601',
      interval: 'seconds',
      weather_code: 'wmo code',
      temperature_2m: '°C',
      apparent_temperature: '°C',
    },
    current: {
      time: '2026-06-03T10:00',
      interval: 900,
      weather_code: 3, // Overcast
      temperature_2m: 14.0,
      apparent_temperature: 12.1,
    },
    hourly_units: {
      time: 'iso8601',
      temperature_2m: '°C',
      weather_code: 'wmo code',
      apparent_temperature: '°C',
    },
    hourly: {
      time: [
        '2026-06-03T00:00',
        '2026-06-03T01:00',
        '2026-06-03T02:00',
        '2026-06-03T03:00',
        '2026-06-03T04:00',
        '2026-06-03T05:00',
        '2026-06-03T06:00',
        '2026-06-03T07:00',
        '2026-06-03T08:00',
        '2026-06-03T09:00',
        '2026-06-03T10:00',
        '2026-06-03T11:00',
        '2026-06-03T12:00',
        '2026-06-03T13:00',
        '2026-06-03T14:00',
        '2026-06-03T15:00',
        '2026-06-03T16:00',
        '2026-06-03T17:00',
        '2026-06-03T18:00',
        '2026-06-03T19:00',
        '2026-06-03T20:00',
        '2026-06-03T21:00',
        '2026-06-03T22:00',
        '2026-06-03T23:00',
      ],
      temperature_2m: [
        13.5, 13.4, 13.4, 13.3, 13.3, 13.4, 13.5, 13.7, 13.9, 14.0, 14.0, 14.1, 14.2, 14.3, 14.3, 14.2, 14.1, 14.0,
        13.9, 13.8, 13.7, 13.6, 13.5, 13.5,
      ],
      weather_code: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      apparent_temperature: [
        11.5, 11.4, 11.3, 11.2, 11.2, 11.4, 11.5, 11.7, 12.0, 12.1, 12.1, 12.2, 12.4, 12.5, 12.5, 12.3, 12.1, 12.0,
        11.9, 11.7, 11.6, 11.5, 11.4, 11.4,
      ],
    },
  },
  {
    name: 'Freezing Winter Snap',
    latitude: 51.5,
    longitude: 0.25,
    generationtime_ms: 0.4321,
    utc_offset_seconds: 0,
    timezone: 'GMT',
    timezone_abbreviation: 'GMT',
    elevation: 1.0,
    current_units: {
      time: 'iso8601',
      interval: 'seconds',
      weather_code: 'wmo code',
      temperature_2m: '°C',
      apparent_temperature: '°C',
    },
    current: {
      time: '2026-06-03T10:00',
      interval: 900,
      weather_code: 71, // Slight Snowfall
      temperature_2m: 0.5,
      apparent_temperature: -3.4,
    },
    hourly_units: {
      time: 'iso8601',
      temperature_2m: '°C',
      weather_code: 'wmo code',
      apparent_temperature: '°C',
    },
    hourly: {
      time: [
        '2026-06-03T00:00',
        '2026-06-03T01:00',
        '2026-06-03T02:00',
        '2026-06-03T03:00',
        '2026-06-03T04:00',
        '2026-06-03T05:00',
        '2026-06-03T06:00',
        '2026-06-03T07:00',
        '2026-06-03T08:00',
        '2026-06-03T09:00',
        '2026-06-03T10:00',
        '2026-06-03T11:00',
        '2026-06-03T12:00',
        '2026-06-03T13:00',
        '2026-06-03T14:00',
        '2026-06-03T15:00',
        '2026-06-03T16:00',
        '2026-06-03T17:00',
        '2026-06-03T18:00',
        '2026-06-03T19:00',
        '2026-06-03T20:00',
        '2026-06-03T21:00',
        '2026-06-03T22:00',
        '2026-06-03T23:00',
      ],
      temperature_2m: [
        -1.2, -1.5, -1.8, -2.0, -2.2, -2.1, -1.8, -1.0, -0.2, 0.2, 0.5, 1.2, 1.8, 2.0, 1.5, 0.8, 0.2, -0.3, -0.8, -1.2,
        -1.5, -1.9, -2.2, -2.5,
      ],
      weather_code: [3, 71, 71, 73, 73, 71, 3, 3, 3, 71, 71, 71, 3, 2, 2, 3, 71, 71, 73, 73, 3, 3, 3, 3],
      apparent_temperature: [
        -5.4, -5.9, -6.3, -6.6, -7.0, -6.8, -6.2, -5.1, -4.3, -3.8, -3.4, -2.5, -1.8, -1.5, -2.1, -3.0, -3.8, -4.5,
        -5.1, -5.6, -6.0, -6.5, -7.1, -7.6,
      ],
    },
  },
];
